import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setRulesDataApi } from "../../../AxiosRtk/DashBoard";
import useFirebase from "../../../../../useFirebase";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import useGallery from "./useGallery";
import { setGalleryEnabledData } from "../../../AxiosRtk/setRulesGallery";
import { setShowMessage } from "../../../AxiosRtk/successMessage";

const Gallery = ({ deviceSelected, getLangTranslation }) => {
  const dispatch = useDispatch();
  const { kidDevicesList, kidList, selectedKidId, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const { getCollectionData } = useFirebase(deviceSelected);
  const [enableData, setEnableData] = useState({});
  const [isToggleEnabled, setIsToggleEnabled] = useState(false);
  const [allFireStoreData, setAllFireStoreData] = useState(null);
  const { handleToggleChange } = useGallery(deviceSelected, allFireStoreData);
  //   function getSetRuleData() {
  //     setRulesDataApi({ kidId: selectedKidId, deviceId: deviceSelected })
  //       .then((res) => {
  //         setEnableData(res?.data?.result);
  //       })
  //       .catch((err) => {
  //         console.log(
  //           "set rules data catch error ==>>",
  //           err?.response?.data?.message
  //         );
  //       });
  //   }

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      dispatch(setRuleDataSetUp(null));
    }
  }, [deviceSelected]);

  useEffect(() => {
    if (setRulesData) {
      setIsToggleEnabled(setRulesData?.gallerysupervision);
      setAllFireStoreData(setRulesData);
    } else {
      setIsToggleEnabled(null);
      setAllFireStoreData(null);
    }
  }, [setRulesData]);

  //   useEffect(() => {
  //     if (deviceSelected) getSetRuleData();
  //   }, [deviceSelected]);

  const handleSubmit = (e) => {
    const { name, checked } = e.target;
    // console.log(checked);
    setGalleryEnabledData({
      deviceId: deviceSelected,
      kidId: selectedKidId,
      is_gallery_monitoring: checked ? 1 : 0,
    })
      .then((res) => {
        if (res?.data?.status) {
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: res?.data?.message,
              message: res?.data?.message,
            })
          );
          handleToggleChange(name, checked);
        }
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      });
  };

  return (
    <>
      <div className="form-check form-switch mb-6">
        <input
          className="form-check-input cursor-pointer"
          id="One"
          type="checkbox"
          role="switch"
          name="GALLERY_ENABLE"
          onChange={(e) => {
            handleSubmit(e);
          }}
          checked={isToggleEnabled?.syncGalleryImageAndVideo || 0}
        />
        <label className="form-check-label text-blue-800 fw-bold" htmlFor="One">
          {getLangTranslation("GALLERY_MONITORING_ALLOW_APPS_TO_SYNC_ALL_LABLE", "Allow app to sync all child gallery images and videos to parent app")}
        </label>
      </div>
      <p className="small">
        {getLangTranslation("GALLERY_MONITORING_ALLOW_APPS_TO_SYNC_ALL_DESCRIPTION", "This feature will allow you to see all the Gallery pictures and videos of your child on your parent app")}.
      </p>
    </>
  );
};

export default Gallery;
